<svelte:options customElement="modal-download" />

<script lang="ts">
  import { UmlautErsetzung, DatumToNormal, DatumToReverse } from "../gdvepublic/js/testscripts";

  let addOrChangeTitle: string = "hinzufügen";
  let curDateReverse: string;
  let curEvtyp: string;
  let lobpreisKey: string = "";
  let lobpreisVal: string = "";
  let predigtKey: string = "";
  let predigtVal: string = "";
  let abschlussKey: string = "";
  let abschlussVal: string = "";
  let zusammenschnittKey: string = "";
  let zusammenschnittVal: string = "";
  let downloadKey: string = "";
  let downloadVal: string = "";
  let keyValuePairsToSave: any[] = [];

  async function GetGodi() {
    return new Promise<any>(async (resolve, reject) => {
      let response = await fetch(`downloads.php?task=getGodi&datum=${DatumToNormal(curDateReverse)}`);
      if (!response.ok) {
        reject("Fehler1");
        return;
      }
      let resj = await response.json();
      let ret: any = resj.success;
      resolve(ret);
    });
  }

  async function SaveKeyValuePairs() {
    return new Promise<any>(async (resolve, reject) => {
      let obj = { task: "add", keyvaluepairs: keyValuePairsToSave };
      let response = await fetch(`downloads.php`, {
        method: "POST",
        body: JSON.stringify(obj),
      });
      if (!response.ok) {
        reject("Fehler1");
        return;
      }
      let resj = await response.json();
      resolve(resj);
    });
  }

  function ResetAllFields(resetDate: boolean = true) {
    lobpreisKey = "";
    lobpreisVal = "";
    predigtKey = "";
    predigtVal = "";
    abschlussKey = "";
    abschlussVal = "";
    zusammenschnittKey = "";
    zusammenschnittVal = "";
    downloadKey = "";
    downloadVal = "";
    curEvtyp = "";
    keyValuePairsToSave = [];
    if (resetDate) {
      curDateReverse = "";
    }
  }

  function DateChanged() {
    console.log("curdatereverse:", curDateReverse);

    curEvtyp = "LOAD";
    GetGodi().then((data) => {
      console.log("getgodi:", data);
      if (data) {
        if (data.length === 1) {
          ResetAllFields();
          let event = data[0];
          curDateReverse = DatumToReverse(event.datum);
          curEvtyp = event.gamfile.eventtypkuerzel || event.eventtypkuerzel || "";
          console.log("curevtyp", curEvtyp);
          let sprecher = event.sprecher === "" ? "" : UmlautErsetzung(event.sprecher.toPascalCase());
          var thema = event.thema === "" ? "" : UmlautErsetzung(event.thema.toPascalCase());

          if (curEvtyp === "GO") {
            lobpreisKey = `${curDateReverse}-lob`;
            lobpreisVal = `${curDateReverse}[GO-01]Lobpreis.mp3`;
            predigtKey = `${curDateReverse}-pre`;
            predigtVal = `${curDateReverse}[GO-02]${sprecher}-${thema}.mp3`;
            abschlussKey = `${curDateReverse}-ab`;
            abschlussVal = `${curDateReverse}[GO-03]Abschluss.mp3`;
          } else if (curEvtyp === "ZUK") {
            zusammenschnittKey = `${curDateReverse}-zuk`;
            zusammenschnittVal = `${curDateReverse}[ZUK]Zusammenschnitt.mp3`;
          }
          console.log(event);
        } else if (data.length > 1) {
          alert("Mehr als ein Event gefunden... Abbruch. Bitte alles von Hand eingeben. ;-)");
        } else {
          console.log("zack");
          ResetAllFields(false);
          curEvtyp = "DOWNLOAD";
        }
      } else if (data.error !== undefined) {
        alert(data.error);
      } else {
        alert("Fehler beim Laden1");
      }
    });
  }
</script>

<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="changeEntryModalLongTitle">
        Eintrag {addOrChangeTitle}
      </h5>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        on:click={() => {
          ResetAllFields();
          window.jQuery("#changeEntryModal").modal("toggle");
        }}
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div>Datum auswählen, GoDi-Typ auswählen, ZIP- und MP3-Daten eintragen.</div>
      <br />
      <div class="input-group">
        Datum:
        <input
          type="date"
          id="downloadDatum"
          placeholder="Datum"
          bind:value={curDateReverse}
          on:change={() => {
            DateChanged();
          }}
        />
      </div>
      <br />
      <div class="input-group">
        <label>
          <input
            type="radio"
            name="godiTyp"
            class="godiTyp"
            id="godiGO"
            checked={curEvtyp == "GO"}
            on:click={() => {
              curEvtyp = "GO";
            }}
          />
          <span class="godiTypText">GO</span>
        </label>
        <label>
          <input
            type="radio"
            name="godiTyp"
            class="godiTyp"
            id="godiZUK"
            checked={curEvtyp == "ZUK"}
            on:click={() => {
              curEvtyp = "ZUK";
            }}
          />
          <span class="godiTypText">ZUK</span>
        </label>
        <label>
          <input
            type="radio"
            name="godiTyp"
            value="DOWNLOAD"
            class="godiTyp"
            id="godiDOWNLOAD"
            checked={curEvtyp == "DOWNLOAD"}
            on:click={() => {
              curEvtyp = "DOWNLOAD";
            }}
          />
          <span class="godiTypText">Allgemein</span>
        </label>
      </div>
      <br />
      {#if curEvtyp == "GO"}
        <div id="goInputGroups">
          <div class="input-group">
            <span class="input-group-addon" id="dlNewKeyMP3LobpreisSpan">Lobpreis-Key</span>
            <input type="text" id="dlNewKeyMP3Lobpreis" class="form-control" placeholder="JJJJ-MM-TT-lob" bind:value={lobpreisKey} />
          </div>
          <div class="input-group">
            <span class="input-group-addon" id="dlNewValMP3LobpreisSpan">Dateiname (Lobpreis-MP3)</span>
            <input type="text" id="dlNewValMP3Lobpreis" class="form-control" placeholder="JJJJ-MM-TT[GO-01]Lobpreis.mp3" bind:value={lobpreisVal} />
          </div>
          <br />
          <div class="input-group">
            <span class="input-group-addon" id="dlNewKeyMP3PredigtSpan">Predigt-Key</span>
            <input type="text" id="dlNewKeyMP3Predigt" class="form-control" placeholder="JJJJ-MM-TT-pre" bind:value={predigtKey} />
          </div>
          <div class="input-group">
            <span class="input-group-addon" id="dlNewValMP3PredigtSpan">Dateiname (Predigt-MP3)</span>
            <input type="text" id="dlNewValMP3Predigt" class="form-control" placeholder="JJJJ-MM-TT[GO-02]Prediger-Thema.mp3" bind:value={predigtVal} />
          </div>
          <br />
          <div class="input-group">
            <span class="input-group-addon" id="dlNewKeyMP3AbschlussSpan">Abschluss-Key</span>
            <input type="text" id="dlNewKeyMP3Abschluss" class="form-control" placeholder="JJJJ-MM-TT-ab" bind:value={abschlussKey} />
          </div>
          <div class="input-group">
            <span class="input-group-addon" id="dlNewValMP3AbschlussSpan">Dateiname (Abschluss-MP3)</span>
            <input type="text" id="dlNewValMP3Abschluss" class="form-control" placeholder="JJJJ-MM-TT[GO-03]Abschluss.mp3" bind:value={abschlussVal} />
          </div>
        </div>
      {:else if curEvtyp == "ZUK"}
        <div id="zukInputGroups">
          <div class="input-group">
            <span class="input-group-addon" id="dlNewKeyMP3ZusammenschnittSpan">Zusammenschnitt-Key</span>
            <input type="text" id="dlNewKeyMP3Zusammenschnitt" class="form-control" placeholder="JJJJ-MM-TT-zuk" bind:value={zusammenschnittKey} />
          </div>
          <div class="input-group">
            <span class="input-group-addon" id="dlNewValMP3ZusammenschnittSpan">Dateiname (Zusammenschnitt-MP3)</span>
            <input type="text" id="dlNewValMP3Zusammenschnitt" class="form-control" placeholder="JJJJ-MM-TT[ZUK]Zusammenschnitt.mp3" bind:value={zusammenschnittVal} />
          </div>
        </div>
      {:else if curEvtyp == "DOWNLOAD"}
        <div id="downloadInputGroups">
          <div class="input-group">
            <span class="input-group-addon" id="dlNewKeySpan">Key</span>
            <input type="text" id="dlNewKey" class="form-control" placeholder="Key" bind:value={downloadKey} />
          </div>
          <div class="input-group">
            <span class="input-group-addon" id="dlNewValSpan">Dateiname</span>
            <input type="text" id="dlNewVal" class="form-control" placeholder="Dateiname" bind:value={downloadVal} />
          </div>
        </div>
      {:else if curEvtyp == "LOAD"}
        <div>Event laden...</div>
      {:else}
        <div>Kein Event gefunden</div>
      {/if}
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        data-dismiss="modal"
        on:click={() => {
          ResetAllFields();
          window.jQuery("#changeEntryModal").modal("toggle");
        }}
      >
        Schließen
      </button>
      <button
        type="button"
        id="changeEntryModalSave"
        class="btn btn-primary"
        on:click={() => {
          if (curEvtyp == "DOWNLOAD") {
            if (downloadKey == "" || downloadVal == "") {
              alert("Nicht alle Felder ausgefüllt");
              return false;
            }
            keyValuePairsToSave = [{ key: downloadKey, val: downloadVal }];
          } else if (curEvtyp == "ZUK") {
            if (zusammenschnittKey == "" || zusammenschnittVal == "") {
              alert("Nicht alle Felder ausgefüllt");
              return false;
            }
            keyValuePairsToSave = [{ key: zusammenschnittKey, val: zusammenschnittVal }];
          } else if (curEvtyp == "GO") {
            if (lobpreisKey == "" || lobpreisVal == "" || predigtKey == "" || predigtVal == "" || abschlussKey == "" || abschlussVal == "") {
              alert("Nicht alle Felder ausgefüllt");
              return false;
            }
            keyValuePairsToSave = [
              { key: lobpreisKey, val: lobpreisVal },
              { key: predigtKey, val: predigtVal },
              { key: abschlussKey, val: abschlussVal },
            ];
          } else {
            alert("Kein Eventtyp ausgewählt");
            return false;
          }
          console.log("keyvalpairs:", keyValuePairsToSave);
          SaveKeyValuePairs().then((res) => {
            console.log("after save", res);
            if (res.error) {
              alert(res.error);
            } else {
              window.jQuery("#changeEntryModal").modal("toggle");
              setTimeout(() => {
                location.reload();
              }, 50);
            }
          });
        }}
      >
        Speichern
      </button>
    </div>
  </div>
</div>

<style>
  @import "../../css/bootstrap.min.css";
  @import "../../css/gdve-styles.css";

  .godiTypText {
    margin-right: 40px;
  }
</style>
